export default "ed7f0744495bdc0e.svg"